import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import ProjectCard from "../../cards/project"

gsap.registerPlugin(ScrollTrigger)

const LatestProject = ({ title, link, projects }) => {


  return (
    <section className="latest-project">
      <div className="latest-project__inner">
        <div className="latest-project__title">
          <div className="line line--horizon center-left"></div>
          {title && <h2>{parse(title)}</h2>}
          {link?.length > 0 && (<Link
            className="btn btn--orange"
            to={link[0].link[0].externalLink ? link[0].link[0].externalLink : link[0].link[0].internalLink.permalink}
          >
            {link[0].title}
          </Link>)}
        </div>

        <div className="latest-project__wrapper">
          <div className="line line--vertical center-top"></div>
          <div className="line line--vertical center-bottom"></div>

          {projects?.length > 0 &&
            <div className="latest-project__items">
              {
                projects?.slice(0, 3).map((el, i) => (
                  <ProjectCard key={i} {...el} />
                ))
              }
            </div>
          }
        </div>
      </div>
    </section>
  )
}

export default LatestProject

export const query = graphql`
fragment LatestProjectProps on DatoCmsLatestProject {
  ... on DatoCmsLatestProject {
    id
    title
    link {
      ...LinkWithTitleProps
    }
    projects {
      title
      thumbnail {
        ...InternalAssetProps
      }
      permalink
      slug
      sectors {
        title
      }
      servicesTags {
        title
      }
    }
  }
}
`
